import React from "react";

const BookingPage = () => {
  return (
    <>
      <div className="booking-container">
        Coming soon...
        {/* <div className="right-side-elements-container">

                </div> */}
      </div>
    </>
  );
};

export default BookingPage;
